import { boards } from "@/mocks/heiliaoHome";

export default function BoardGrid() {
  return (
    <section id="boards" className="w-full bg-background-100/70">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-10 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4 mb-5 md:mb-7">
          <div className="max-w-2xl">
            <div className="flex items-center gap-2 mb-3">
              <span className="h-4 w-1 rounded-full bg-primary-500"></span>
              <span className="text-xs font-semibold tracking-[0.2em] text-primary-700 uppercase">板块分区 · 分区感拉满</span>
            </div>
            <h2 className="font-serif text-2xl md:text-4xl font-black text-foreground-950 leading-tight">
              厚壳运营 · 一块一块逛进来
            </h2>
          </div>
          <a
            href="#"
            onClick={(e) => e.preventDefault()}
            className="whitespace-nowrap inline-flex items-center gap-2 rounded-md bg-background-50 border border-background-300/70 px-4 py-2 text-sm font-medium text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部板块 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
          {boards.map((b) => (
            <a
              key={b.title}
              href="#"
              onClick={(e) => e.preventDefault()}
              className="group flex items-start gap-3.5 rounded-lg border border-background-200/70 bg-background-50 p-4 md:p-5 hover:-translate-y-0.5 hover:border-primary-200 hover:bg-background-50 transition-all cursor-pointer"
            >
              <span className={`grid place-items-center h-11 w-11 shrink-0 rounded-lg ${b.chipClass}`}>
                <i className={`${b.icon} text-xl`}></i>
              </span>
              <span className="flex flex-col min-w-0">
                <span className="flex items-center justify-between gap-2">
                  <span className="font-serif text-[15px] md:text-base font-bold text-foreground-950 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    {b.title}
                  </span>
                  <i className="ri-arrow-right-up-line text-foreground-300 group-hover:text-primary-500 group-hover:translate-x-0.5 transition-all"></i>
                </span>
                <span className="mt-1 text-xs leading-relaxed text-foreground-500 line-clamp-2">{b.desc}</span>
                <span className="mt-2 text-[11px] font-medium text-foreground-400">已聚集 {b.posts}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}